import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name:'routines',
  initialState:{
    new:"tests",
    records: [],
    loading: false,
    showForm : false,
    runRoutineState : false,
    selected_record:[]
  },
  reducers:{
    toggleForm:(routines,action)=>{
      routines.showForm = action.payload;
    },
    toggleRunRoutine:(routines,action)=>{
      routines.runRoutineState = action.payload;
    },
    setRoutines:(routines,action)=>{
      routines.records = action.payload;
      routines.showForm = false;
      routines.runRoutineState = false;
      routines.selected_record = [];
      // routines.records.push(action.payload)
    },
    removeSelectedRoutine:(routines,action)=>{
      routines.selected_record = [];
    },
    selectedRoutine:(routines,action)=>{
      routines.selected_record = action.payload;
      routines.showForm = true;
      routines.runRoutineState = false;
    },
    runRoutine:(routines,action)=>{
      routines.selected_record = action.payload;
      routines.showForm = false;
      routines.runRoutineState = true;
    }
    
  }
})

// export function getCurrentUser() {
//   debugger;
//   return 'test';
// }

// console.log(slice);
export const {setRoutines, toggleForm, removeSelectedRoutine, selectedRoutine,toggleRunRoutine,runRoutine } = slice.actions;
export default slice.reducer;

//Action Creators
export const loadRoutinesAction = () => apiCallBegan({
  url:"/routine",
  method:"get",
  onSuccess:setRoutines
})
export const saveUpdateRoutinesAction = (id = null,data) => apiCallBegan({
  url:(id)?`/routine/edit/${id}`:`/routine/edit`,
  method:"post",
  data:data,
  onSuccess:loadRoutinesAction
})

export const deleteRoutineAction = (id) => apiCallBegan({
  url:`/routine/delete/${id}`,
  method:"get",
  onSuccess:setRoutines
})
export const setselectedRoutineAction = (id) => apiCallBegan({
  url:`/routine/edit/${id}`,
  method:"get",
  onSuccess:selectedRoutine
})
export const runRoutinesAction = (id) => apiCallBegan({
  url:`/routine/edit/${id}`,
  method:"get",
  onSuccess:runRoutine
})
